import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    units: [],
};
export var types = {
    SET_UNITS: 'setUnits',
};
export var units = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
